import {GetReserveRoutes} from "@/services/reserve";
import router from "@/router";
import {CyrillicToLatin} from "@/utils/stringHelper";
import useRouterStore, {RouteGroups} from "@/stores/useRouterStore";
import {useAuthStore} from "@/stores/auth";

export async function InitReserveRoutes() {
    const authStore = useAuthStore();
    const hasUser = !!authStore.userData;
    if (!hasUser) return;

    const routes = await GetReserveRoutes();
    const routeStore = useRouterStore();

    router.addRoute({
        path: "/reserves",
        name: "reserves",
        component: () => import("@/layouts/Default.vue"),
        children: routes.data.data.map((route) => ({
            path: CyrillicToLatin(reformatName(route.title)),
            name: `reserves.${route.id}`,
            meta: {
                type: {...route, title: route.title.replace(":", "и")},
                middleware: "auth",
                accesses_redirect: true
            },
            component: () => import("@/views/reserve/Profiles.vue"),
        })),
    });

    const group = routeStore.addGroup(RouteGroups.RESERVE, 1);
    group.children.push({
        name: "reserves",
        slug: "reserves",

        children: routes.data.data.map((route) => {
            const name = reformatName(route.title, " и ").toUpperCase();
            return {
                name: route.short_title
                    ? route.short_title.replace(":", "и")
                    : route.translated_title.replace(":", "и"),
                title: route.short_title
                    ? route.short_title.replace(":", "и")
                    : route.translated_title.replace(":", "и"),
                slug: CyrillicToLatin(reformatName(route.title)),
                to: {name: `reserves.${route.id}`},
            };
        }),
    });
}

const reformatName = (str, joinAnd = "-") => {
    return str
        .split(" ")
        .map((str) => str.charAt(0))
        .join("")
        .toLowerCase()
        .split(":")
        .join(joinAnd);
};
